/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { PopperPlacementType } from "../components/core";

export function getPopperPlacementVariation<TPlacement extends PopperPlacementType>(
	placement: TPlacement
): TPlacement extends `${string}-${infer R}` ? R : undefined {
	return placement.split("-")[1] as any;
}
